export const schemaMapLibre = (props) => {
  return {
    required: [],
      fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: [],
      },  
      {
        id: 'style',
        title: 'Map Style',
        fields: ['height','align', 'API_KEY', 'mapStyleURL'],
      },
      {
        id: 'map',
        title: 'Map Initial View',
        fields: ['lng', 'lat', 'bearing', 'zoom', 'pitch'],
      },
      {
        id: 'overlay',
        title: 'Map Overlays',
        fields: ['geojson', 'icons'],
      },
    ],
    properties: {
      title: {
        title: 'Title',
        widget: 'text',
      },
      description: {
        title: 'Description',
        widget: 'text',
      },
      align: {
        title: 'Align',
	widget: 'align',
      },
      API_KEY: {
        title: 'API_KEY for Style URL',
        widget: 'text',
      },
      mapStyleURL: {
        title: 'Map Style URL',
        widget: 'object_browser',
        mode: 'link',
        allowExternals: true,
      },
      lng: {
        title: 'Longitude',
        widget: 'text',
      },
      lat: {
        title: 'Latitude',
        widget: 'text',
      },
      bearing: {
        title: 'Bearing',
        widget: 'int',
      },
      zoom: {
        title: 'Zoom',
        widget: 'int',
      },
      pitch: {
        title: 'Pitch',
        widget: 'int',
      },
      height: {
        title: 'Map Height',
	initialValue: "60vh",
        widget: 'int',
      },
      geojson: {
        title: 'GeoJSON Folder',
        widget: 'object_browser',
        mode: 'multiple',
	initialValue: null,
        allowExternals: false,
      },
      icons: {
        title: 'Icon Folder',
        widget: 'object_browser',
        mode: 'link',
	initialValue: null,
        allowExternals: false,
      },
    },
  };
};

export default schemaMapLibre;
